import _ from 'lodash'
import {
  SET_QUESTIONNAIRE_DATA,
  SET_CURRENT_PROGRESS,
  NEW_RECORD_SAVED,
  ADD_FAILED_SAVE,
  INCREMENT_SAVE_NUMBER,
  RESET_SAVE_DATA,
  ADD_MODIFIED_RECORD,
  REMOVE_MODIFIED_RECORD,
  SET_CURRENT_RESULT_ID,
  ADD_CONTEXT_VALIDATION_FAILED,
  REMOVE_CONTEXT_VALIDATION_FAILED,
  ADD_SAVE_TO_EXECUTE_IN_SEQUENCE,
  RESET_SAVE_QUEUE,
} from '@/store/mutation-types'

export default {
  namespaced: true,
  state: {
    campaigns: [],
    groups: null,
    formValues: null,
    currentProgress: null,
    unitsOfMeasure: {},
    numberOfSaves: 0,
    numberOfFailedSaves: 0,
    currentResultId: null,
    // Set and Map are not reactive in VUE 2.x
    modifiedRecords: [],
    failedContextValidations: [],
    savesToExecuteInSequence: [],
  },

  mutations: {
    [ADD_SAVE_TO_EXECUTE_IN_SEQUENCE](state, payload) {
      state.savesToExecuteInSequence.push(payload)
    },
    [REMOVE_CONTEXT_VALIDATION_FAILED](state, payload) {
      state.failedContextValidations.delete(payload)
    },
    [ADD_CONTEXT_VALIDATION_FAILED](state, payload) {
      state.failedContextValidations.push(payload)
    },
    [SET_QUESTIONNAIRE_DATA](state, payload) {
      state.campaigns = payload.campaigns
      state.groups = payload.groups
      state.formValues = payload.formValues
      state.unitsOfMeasure = payload.unitsOfMeasure
    },
    [SET_CURRENT_PROGRESS](state, currentProgress) {
      state.currentProgress = currentProgress
    },
    [NEW_RECORD_SAVED](state, group) {
      const update = function increment(progress) {
        progress.completed += 1
        progress.outstanding -= 1
        progress.progress = (100 * progress.completed) / (progress.completed + progress.outstanding)
      }
      update(state.currentProgress.overallProgress)
      update(state.currentProgress.groupProgress[group])
    },
    [ADD_FAILED_SAVE](state) {
      state.numberOfFailedSaves += 1
    },
    [INCREMENT_SAVE_NUMBER](state) {
      state.numberOfSaves += 1
    },
    [RESET_SAVE_DATA](state) {
      state.numberOfSaves = 0
      state.numberOfFailedSaves = 0
      state.modifiedRecords = _.clone(state.failedContextValidations)
      state.failedContextValidations = []
    },
    [ADD_MODIFIED_RECORD](state, payload) {
      if (!_.includes(state.modifiedRecords, payload)) {
        state.modifiedRecords.push(payload)
      }
    },
    [REMOVE_MODIFIED_RECORD](state, payload) {
      state.modifiedRecords.splice(state.modifiedRecords.indexOf(payload), 1)
    },
    [SET_CURRENT_RESULT_ID](state, id) {
      state.currentResultId = id
    },
    [RESET_SAVE_QUEUE](state) {
      state.savesToExecuteInSequence = []
    },
  },
  actions: {
    resetSaveQueue({ commit }) {
      commit(RESET_SAVE_QUEUE)
    },
    addSaveToExecuteInSequence({ commit }, payload) {
      commit(ADD_SAVE_TO_EXECUTE_IN_SEQUENCE, payload)
    },
    removeFailedContextValidation({ commit }, payload) {
      commit(REMOVE_CONTEXT_VALIDATION_FAILED, payload)
    },
    addFailedContextValidation({ commit }, payload) {
      commit(ADD_CONTEXT_VALIDATION_FAILED, payload)
    },
    setQuestionnaireData({ commit }, payload) {
      commit(SET_QUESTIONNAIRE_DATA, payload)
      commit(RESET_SAVE_DATA)
    },
    setCurrentProgress({ commit }, currentProgress) {
      commit(SET_CURRENT_PROGRESS, currentProgress)
    },
    newRecordSaved({ commit }, group) {
      commit(NEW_RECORD_SAVED, group)
    },
    addFailedSave({ commit }) {
      commit(ADD_FAILED_SAVE)
    },
    incrementSaveNumber({ commit }) {
      commit(INCREMENT_SAVE_NUMBER)
    },
    addModifiedRecord({ commit }, payload) {
      commit(ADD_MODIFIED_RECORD, payload)
    },
    removeModifiedRecord({ commit }, payload) {
      commit(REMOVE_MODIFIED_RECORD, payload)
    },
    resetSaveData({ commit }) {
      commit(RESET_SAVE_DATA)
    },
    setCurrentResultId({ commit }, id) {
      commit(SET_CURRENT_RESULT_ID, id)
    },
  },
  getters: {
    campaigns(state) {
      return state.campaigns
    },
    groups(state) {
      return state.groups
    },
    groupProgress: (state) => (group) => {
      return group
        ? state.currentProgress?.groupProgress[group]
        : state.currentProgress?.groupProgress
    },
    overallProgress(state) {
      return state.currentProgress?.overallProgress
    },
    isSaveAllComplete(state) {
      return (
        state.modifiedRecords.length > 0 && state.modifiedRecords.length === state.numberOfSaves
      )
    },
    areAllSavesCollected(state) {
      return (
        state.modifiedRecords.length > 0 &&
        state.modifiedRecords.length === state.savesToExecuteInSequence.length
      )
    },
    getOrderedSaveQueue(state) {
      // Sorting by id does not give us consistent results, assuming that the published events are
      // processed by components in the same order they are rendered
      return state.savesToExecuteInSequence
    },
    getConversionUnits: (state) => (targetUnitId) => {
      return state.unitsOfMeasure[targetUnitId] || []
    },
  },
}
